
export default  [
    {
        class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
        type: 'boolean',
        field: 'ocultar',
        label: 'Ocultar Conteúdo',
        info:'Se esse campo estiver habilitado, esse conteúdo não será exibido no documento final LTCAT',
        rules: ['required']
    },
    {
        class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
        type: 'text',
        field: 'ocultar_texto',
        label: 'Substituir o Conteúdo pelo Texto Abaixo',
        placeholder: 'Não se aplica',
        info: 'Ao ocultar o item, você pode definir um teste padrão que será mostrado no item em questão',
        rules: ['']
    },
    {
        class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
        type: 'select-custom',
        field: 'fator_riscos',
        label: 'Mostrar SOMENTE para os seguintes Fatores de Riscos',
        multiple:true,
        option: {
            key: 'id',
            label: 'nome',
            value: 'id'
        },
        info: 'Aqui você pode definir uma exceção para o bloqueio do campo. Insira os fatores de riscos que permitirão a visualização do conteúdo no documento LTCAT. Deixe em branco para bloquear totalmente.',
        rules: ['']
    },
];




// WEBPACK FOOTER //
// ./src/components/apps/web/ltcat/configuracao/modelo/_form/conteudo-editar.js